import React from 'react';
import Wrapper from '../wrapper/Wrapper';
import { Container, Row, Col } from 'react-bootstrap';
var staticJSS = {
  fields: [{
    "name": "camarillo",
    "navigationTitle": "Camarillo",
    "hideInNavigation": false,
    "url": "http://crackerbarrel.dev.local/Locations/States/ca/camarillo"
  }, {
    "name": "rialto",
    "navigationTitle": "Rialto",
    "hideInNavigation": false,
    "url": "http://crackerbarrel.dev.local/Locations/States/ca/rialto"
  }, {
    "name": "rocklin",
    "navigationTitle": "Rocklin",
    "hideInNavigation": false,
    "url": "http://crackerbarrel.dev.local/Locations/States/ca/rocklin"
  }, {
    "name": "sacramento",
    "navigationTitle": "Sacramento",
    "hideInNavigation": false,
    "url": "http://crackerbarrel.dev.local/Locations/States/ca/sacramento"
  }, {
    "name": "santa-maria",
    "navigationTitle": "Santa Maria",
    "hideInNavigation": false,
    "url": "http://crackerbarrel.dev.local/Locations/States/ca/santa-maria"
  }, {
    "name": "victorville",
    "navigationTitle": "Victorville",
    "hideInNavigation": false,
    "url": "http://crackerbarrel.dev.local/Locations/States/ca/victorville"
  }]
};
export var LocationList = function LocationList(props) {
  var jssInfo = [];

  if (Array.isArray(props.fields)) {
    jssInfo = props.fields;
  }

  if (props.fields) {
    jssInfo = Object.values(props.fields);
  }

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Wrapper, {
    layout: {
      padding: "medium",
      background: "default"
    },
    className: "minheight-20 cb-location-list"
  }, /*#__PURE__*/React.createElement(Row, null, jssInfo.map(function (el, index) {
    var navigationTitle = el.navigationTitle,
        url = el.url;
    return /*#__PURE__*/React.createElement(Col, {
      lg: "3",
      sm: "12",
      key: index
    }, /*#__PURE__*/React.createElement("a", {
      href: url
    }, navigationTitle));
  }))));
};